import enviro from 'enviro';

/** Ids which are passed to the BE to determine which assistant to use
 * These are the ids of the assistants in the HubGpt API
 * When you select the SalesGPT 4o model.
 *
 * These are stable to hardcode
 */
const SALES_COPILOT_ASSISTANT_ID_PROD = 7606;
const SALES_COPILOT_ASSISTANT_ID_DEV = 2147494661;

/** This ID is stable and is okay to hardcode */
export const getAssistantId = () => {
  if (enviro.isProd()) {
    return SALES_COPILOT_ASSISTANT_ID_PROD;
  }
  return SALES_COPILOT_ASSISTANT_ID_DEV;
};